// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iSU5","colBig":"styles_colBig__2xY-C","colSmall":"styles_colSmall__2k1KH","shopifyNameWrapper":"styles_shopifyNameWrapper__AQQ5j"};